import React, { Fragment, useContext, useLayoutEffect, useRef } from "react";
import date from "date-and-time";
import Reward from "react-rewards";
import { UiContext } from "contexts/ui-context";
import IconHappy from "../../assets/svg/icon-happy.svg";

/**
 * Context API
 */
import useModal from "hooks/use-modal";

/**
 * Components
 */
import { FlexRow } from "components/flex-row/flex-row";
import BaseButton from "components/base-button/base-button";
import Heading from "components/heading/heading";
import IconSvgComponent from "components/svg-icon/svg-icon";
import Spacer from "components/spacer/spacer";
import { formatMoney } from "../../utils/formatMoney";
import IconBankAlt from "../../assets/svg/icon-bank-alt.svg";

const ModalOfferAccept = (props) => {
  const { openModal, modalTypes } = useModal();
  const { account, submitAmount, offer_id } = props.modalProps;
  const pattern = date.compile("DD MMM YYYY");
  const dateOpened = new Date(account.opened);
  const { toggleChat } = useContext(UiContext);
  const rewardRef = useRef();

  const typeString =
    account.type.charAt(0).toUpperCase() + account.type.slice(1);

  useLayoutEffect(() => {
    console.log("do this");
    console.log(rewardRef);
    rewardRef.current.rewardMe();
  }, []);

  return (
    <Fragment>
      <div style={{ position: "absolute", left: "50%" }}>
        <Reward
          ref={rewardRef}
          type="confetti"
          config={{
            startVelocity: 20,
            spread: 90,
            zIndex: -100,
            springAnimation: false,
            colors: ["#6F86B3", "#93A6CC", "#DEE5F4", "#96B5F4", "#5783D1"],
          }}
        >
          <div className="sticky-icon">
            <IconSvgComponent icon={IconHappy} />
          </div>
        </Reward>
      </div>
      <div className="modal__heading">
        <h2>Congratulations!</h2>
        <h4>Your offer was accepted</h4>
      </div>
      <Heading text={account.creditor.name} icon={IconBankAlt} />
      <dl>
        <dt>Reference Number</dt>
        <dd>#{account.creditor.ref_id}</dd>

        <dt>Balance</dt>
        <dd>${formatMoney(account.balance_current, 2, ".", ",")}</dd>

        <dt>Status</dt>
        <dd>{typeString}</dd>
      </dl>
      <Spacer height="10" />
      <dl>
        <dt>Resolution Offer</dt>
        <dd>${formatMoney(submitAmount, 2, ".", ",")}</dd>
      </dl>
      <FlexRow className="justify-content--space-between">
        <BaseButton
          type="button"
          className="btn--primary"
          onClick={() =>
            openModal(modalTypes.ModalMakePayment, {
              account,
              offer_id: offer_id,
              amount: formatMoney(submitAmount, 2, ".", ","),
            })
          }
        >
          Make Payment
        </BaseButton>
      </FlexRow>
    </Fragment>
  );
};

export default ModalOfferAccept;
